import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/scss/reset.scss";
import "./assets/scss/var.scss";
import "./assets/scss/global.scss";
import { RouterProvider } from "react-router-dom";
import router from "./routes";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
